import { createSlice } from "@reduxjs/toolkit";

// ----------------------------------------------------------------------

const slice = createSlice({
    name: "carrier",
    initialState: {
        isUPSActivated: false,
        isUPSCanadaActivated: false,
        isFedexActivated: false
    },
    reducers: {
        updateUPSActivity(state, action) {
            state.isUPSActivated = action.payload;
        },
        updateUPSCanadaActivity(state, action) {
            state.isUPSCanadaActivated = action.payload;
        },
        updateFedexActivity(state, action) {
            state.isFedexActivated = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

// Actions
export const {
    updateUPSActivity,
    updateUPSCanadaActivity,
    updateFedexActivity
} = slice.actions;
